export default __webpack_public_path__ + "static/media/eventsPic.b774bd83.png";